import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Breadcrumb, Form } from 'antd';
import { submitModalState } from 'shared/constant';

import HeaderSteps from 'components/HeaderSteps';
import AlertModal from '../../components/AlertModal/AlertModal.component';
import organizationRoute from '../../route';

import text from './EmployeeRegister.page.translation';

import FormEmployeeRegister from './EmployeeRegister.form';

const EmployeeRegisterForm = Form.create()(FormEmployeeRegister);

export class EmployeeRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeId: this.props.match.params.id || '',
      formEmployeeSubmit: {
        isFetching: false,
      },
    };
    this._handleSubmit = this._handleSubmit.bind(this);
    this.cdmSetState = this.cdmSetState.bind(this);
  }

  componentDidMount() {
    const { resetSubmitModal } = this.props;
    resetSubmitModal();

    const userId = this.props.me.user_details.user_id;
    this.props.getRolesByUserId(userId, this.callbackGetInitialUserRoles);
  }

  callbackGetInitialUserRoles = () => {
    if (this.state.employeeId) {
      this.props.getSingleEmployee(this.state.employeeId, this.cdmSetState);
    }
  };

  cdmSetState = () => {
    const {
      initialUserRoles,
      employeeDetails,
      updateInitialUserRoles,
    } = this.props;
    const checkedRoles = [...initialUserRoles];
    const userRoles = employeeDetails.payload.user_details.user_role;

    for (let i = 0; i < checkedRoles.length; i += 1) {
      for (let j = 0; j < userRoles.length; j += 1) {
        if (initialUserRoles[i].id === userRoles[j].id) {
          initialUserRoles[i].checked = true;
          break;
        }
      }
    }

    updateInitialUserRoles(false, checkedRoles);
  };

  _getApiParams = submitParams => {
    const params = {};

    params.user = {
      email: submitParams.email.toLowerCase(),
      roles: submitParams.employeeRoles.map(x => x.id),
      phone_mobile: submitParams.employeePhone,
    };

    // Name split
    const splitName = submitParams.employeeName.split(' ');
    const firstName = splitName[0];
    let lastName = splitName.shift();
    lastName = splitName.toString();
    lastName = lastName.split(',').join(' ');

    if (lastName === '') {
      lastName += firstName;
    }

    params.employee = {
      organization_id: this.props.me.organization_details.organization_id,
      firstname: firstName,
      lastname: lastName,
      ktp_num: submitParams.ktp_num,
    };

    params.avatar = submitParams.employeePicture;

    if (this.state.employeeId) {
      const { employeeDetails } = this.props;

      const getUserId = _.get(
        employeeDetails,
        'payload.user_details.user_id',
        '',
      );
      const getEmployeeId = _.get(employeeDetails, 'payload.employee_id', '');
      const getParentId = _.get(employeeDetails, 'payload.parent_id', '');

      params.employee.parent_id = getParentId;
      params.user_id = getUserId;
      params.employee_id = getEmployeeId;
    }

    return params;
  };

  _handleSubmit = submitParams => {
    const params = this._getApiParams(submitParams);

    if (this.state.employeeId) {
      this.props.updateEmployee(params);
    } else {
      this.props.createNewEmployee(params);
    }
  };

  confirmRollback = () => {
    if (
      this.state.employeeId ||
      this.props.submitAddUserState === submitModalState.FAILED
    ) {
      this.props.updateSubmitModalErrorOpen(false);
      this.props.updateCreateNewCompanyStep(2);
    } else {
      this.props.startRollbackUser(this.props.createNewCompanyParams);
    }
  };

  renderModalConfirm = () => {
    const {
      intl: { formatMessage },
      rollbackModalOpen,
      cancelRollbackModal,
    } = this.props;

    const title = formatMessage(text.rollbackConfirmationTitle);
    const description = formatMessage(text.rollbackConfirmationDescription);
    const btnOk = formatMessage(text.rollbackConfirmationBtnOk);
    const btnCancel = formatMessage(text.rollbackConfirmationBtnCancel);

    return (
      <AlertModal
        visible={rollbackModalOpen}
        type="confirm"
        title={title}
        description={description}
        primaryBtnText={btnOk}
        primaryBtnClick={this.confirmRollback}
        cancelBtnText={btnCancel}
        cancelBtnClick={cancelRollbackModal}
      />
    );
  };

  renderRollbackModalFinish = () => {
    const {
      rollbackModalFinishOpen,
      isRollbackSuccess,
      rollbackFinish,
      intl: { formatMessage },
    } = this.props;

    if (rollbackModalFinishOpen) {
      if (isRollbackSuccess) {
        return (
          <AlertModal
            visible={rollbackModalFinishOpen}
            type="alert"
            title={formatMessage(text.rollbackSuccessTitle)}
            description={formatMessage(text.rollbackSuccessDescription)}
            primaryBtnText={formatMessage(text.rollbackSuccessBtnOk)}
            primaryBtnClick={rollbackFinish}
          />
        );
      }

      return (
        <AlertModal
          visible={rollbackModalFinishOpen}
          type="alert"
          title={formatMessage(text.rollbackErrorTitle)}
          description={formatMessage(text.rollbackErrorDescription)}
          primaryBtnText={formatMessage(text.rollbackErrorBtnRetry)}
          primaryBtnClick={this.retryRollback}
        />
      );
    }

    return null;
  };

  retryRollback = () => {
    const {
      submitAddUserState,
      createNewCompanyParams,
      startRollbackUser,
    } = this.props;

    if (submitAddUserState === submitModalState.ROLLBACK) {
      startRollbackUser(createNewCompanyParams);
    }
  };

  onCancelModal = () => {
    this.props.showRollbackModal();
  };

  retryUser = () => {
    this.props.startRetryUser(this.props.createNewCompanyParams);
  };

  retryEmployee = () => {
    this.props.startRetryEmployee(this.props.createNewCompanyParams);
  };

  retryUpdateUser = () => {
    this.props.startRetryUpdateUser(this.props.createNewCompanyParams);
  };

  retryUpdateEmployee = () => {
    this.props.startRetryUpdateEmployee(this.props.createNewCompanyParams);
  };

  getSubmitModalSteps = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    if (this.state.employeeId) {
      return [
        {
          title: formatMessage(text.employeeFormUpdateUserTitle),
          icon: 'ModalUserIcon',
          status: this.props.submitAddUserState,
          retry: this.retryUpdateUser,
        },
        {
          title: formatMessage(text.employeeFormUpdateEmployeeTitle),
          icon: 'ModalEmployeeIcon',
          status: this.props.submitAddEmployeeState,
          retry: this.retryUpdateEmployee,
        },
      ];
    }
    return [
      {
        title: formatMessage(text.employeeFormCreateUserTitle),
        icon: 'ModalUserIcon',
        status: this.props.submitAddUserState,
        retry: this.retryUser,
      },
      {
        title: formatMessage(text.employeeFormCreateEmployeeTitle),
        icon: 'ModalEmployeeIcon',
        status: this.props.submitAddEmployeeState,
        retry: this.retryEmployee,
      },
    ];
  };

  render() {
    const {
      intl: { formatMessage },
      createNewCompanyStep,
    } = this.props;
    let btnText = '';
    let breadcrumbText = '';
    let titleText = '';
    if (this.state.employeeId) {
      btnText = formatMessage(text.btnEdit);
      breadcrumbText = formatMessage(text.breadcrumbEdit);
      titleText = formatMessage(text.editTitle);
    } else {
      titleText = formatMessage(text.formLeftTitle);
      btnText = formatMessage(text.btnRegister);
      breadcrumbText = formatMessage(text.breadcrumbRegister);
    }

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={organizationRoute.EMPLOYEE_LIST}>
                {formatMessage(text.breadcrumbList)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{breadcrumbText}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper ptop25">
          <div id="form-register-employee" className="form-wrapper">
            <HeaderSteps
              currentStep={createNewCompanyStep}
              stepOneTitle={formatMessage(text.employeeStepOneTitle)}
              stepOneDescription={formatMessage(
                text.employeeStepOneDescription,
              )}
              stepTwoTitle={formatMessage(text.employeeStepTwoTitle)}
              stepTwoDescription={formatMessage(
                text.employeeStepTwoDescription,
              )}
              stepThreeTitle={formatMessage(text.employeeStepThreeTitle)}
              stepThreeDescription={formatMessage(
                text.employeeStepThreeDescription,
              )}
            />
            <EmployeeRegisterForm
              onSubmit={this._handleSubmit}
              titleText={titleText}
              btnText={btnText}
              isFetching={this.state.formEmployeeSubmit.isFetching}
              employeeId={this.state.employeeId}
              onCancelModal={this.onCancelModal}
              getSubmitModalSteps={this.getSubmitModalSteps}
              {...this.props}
            />
          </div>
        </div>

        {/* <SubmitModal
          visible={this.props.submitModalOpen}
          steps={submitModalSteps}
          handleCancel={this.onCancelModal}
          title={title}
        /> */}
        {this.renderModalConfirm()}
        {this.renderRollbackModalFinish()}
      </div>
    );
  }
}

EmployeeRegister.propTypes = {
  getSingleEmployee: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  submitModalFinishOpen: PropTypes.bool.isRequired,
  me: PropTypes.object.isRequired,
  createNewEmployee: PropTypes.func.isRequired,
  startRetryUser: PropTypes.func.isRequired,
  createNewCompanyParams: PropTypes.object.isRequired,
  startRetryEmployee: PropTypes.func.isRequired,
  submitAddUserState: PropTypes.string.isRequired,
  submitAddEmployeeState: PropTypes.string.isRequired,
  updateSubmitModalFinishOpen: PropTypes.func.isRequired,
  showRollbackModal: PropTypes.func,
  rollbackModalOpen: PropTypes.bool,
  cancelRollbackModal: PropTypes.func,
  isRollbackSuccess: PropTypes.bool,
  rollbackModalFinishOpen: PropTypes.bool,
  rollbackFinish: PropTypes.func,
  startRollbackUser: PropTypes.func,
  updateEmployee: PropTypes.func,
  startRetryUpdateUser: PropTypes.func,
  startRetryUpdateEmployee: PropTypes.func,
  updateSubmitModalErrorOpen: PropTypes.func,
  submitModalErrorOpen: PropTypes.bool,
  match: PropTypes.object,
  getRolesByUserId: PropTypes.func,
  initialUserRoles: PropTypes.array,
  createNewCompanyStep: PropTypes.number,
  resetSubmitModal: PropTypes.func,
  employeeDetails: PropTypes.object,
  updateInitialUserRoles: PropTypes.func,
  updateCreateNewCompanyStep: PropTypes.func,
};

export default EmployeeRegister;
